import useTheme from 'branding/theme';
const useComponentMargin = ({ margin, marginHorizontal, marginVertical, marginTop, marginBottom, marginLeft, marginRight }) => {
    const { sizing: { component: componentSizing } } = useTheme();
    return {
        ...(margin && { margin: componentSizing.margin[margin] }),
        ...(marginHorizontal && {
            marginLeft: componentSizing.margin[marginHorizontal],
            marginRight: componentSizing.margin[marginHorizontal]
        }),
        ...(marginVertical && {
            marginTop: componentSizing.margin[marginVertical],
            marginBottom: componentSizing.margin[marginVertical]
        }),
        ...(marginTop && { marginTop: componentSizing.margin[marginTop] }),
        ...(marginBottom && { marginBottom: componentSizing.margin[marginBottom] }),
        ...(marginLeft && { marginLeft: componentSizing.margin[marginLeft] }),
        ...(marginRight && { marginRight: componentSizing.margin[marginRight] })
    };
};
export default useComponentMargin;
//# sourceMappingURL=index.js.map